import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import loginImg from '../assets/images/login.png';
import { Link , useNavigate } from 'react-router-dom';
import axios from 'axios';
import API from '../api';

const LoginForm = () => {
  
  const navigate = useNavigate();
  const [mobileNumber, setMobileNumber] = useState('');
  const [otp, setOtp] = useState('');
  const [step, setStep] = useState(1); // 1 = mobile input, 2 = OTP input
  const [message, setMessage] = useState('');
  const [mobileAlert, setMobileAlert] = useState(false);

  // Send OTP
  const handleSendOtp = async (e) => {
    e.preventDefault();

    if (!/^\d{10}$/.test(mobileNumber)) {
      setMobileAlert(true);
      return;
    }
    setMobileAlert(false);

    try {
      console.log('testing 1')
      const res = await API.post("/api/registration/login/verification", { phone: mobileNumber });
      setMessage(res.data.message || "OTP sent successfully!");
      alert("Login Successful")
      navigate('/');
      window.location.reload();
      setStep(2);
    } catch (error) {
      setMessage("Failed to send OTP",error);
      console.log(error)
    }
  };

  // Verify OTP
  const handleVerifyOtp = async (e) => {
    e.preventDefault();

    if (otp.trim() === "") {
      setMessage("Please enter OTP");
      return;
    }

    try {
      const res = await axios.post("http://localhost:5000/verify-otp", {
        phone: mobileNumber,
        otp: otp,
      });

      if (res.data.success) {
        setMessage("✅ Login successful!");

      } else {
        setMessage("❌ Invalid OTP");
      }

    } catch (error) {
      setMessage("Verification failed");
    }

  };

  return (
    <div className="container py-5">
      <Link to="/" className="btn btn-success">Back home →</Link>

      <div className="row align-items-center">
        <div className="col-md-6">
          <img className="img-fluid" src={loginImg} alt="Login" />
        </div>
        <div className="col-md-6">
          <div className="card shadow-sm p-4">
            <h2 className="mb-4">Login with OTP</h2>

            {step === 1 && (
              <form onSubmit={handleSendOtp}>
                <div className="form-floating mb-3">
                  <input
                    type="tel"
                    id="mobileNumber"
                    className="form-control"
                    placeholder="9876543210"
                    value={mobileNumber}
                    onChange={(e) => setMobileNumber(e.target.value)}
                  />
                  <label htmlFor="mobileNumber" className="form-label">Mobile Number</label>
                  {mobileAlert && (
                    <h6 className="text-danger mt-1">
                      <i className="bi bi-exclamation-circle-fill"></i> Enter a valid 10-digit Mobile Number
                    </h6>
                  )}
                </div>
                <button type="submit" className="btn btn-primary w-100">Send OTP</button>
              </form>
            )}

            {step === 2 && (
              <form onSubmit={handleVerifyOtp}>
                <div className="form-floating mb-3">
                  <input
                    type="text"
                    id="otp"
                    className="form-control"
                    placeholder="Enter OTP"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                  />
                  <label htmlFor="otp" className="form-label">Enter OTP</label>
                </div>
                <button type="submit" className="btn btn-success w-100">Verify OTP</button>
              </form>
            )}

            {message && <p className="mt-3">{message}</p>}

            
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
